import { cva } from "class-variance-authority";

export const registrationFeedbackNpsRootStyles = cva([
  "flex w-full flex-col items-stretch gap-6 text-left",
  "lg:items-center lg:gap-8 lg:text-center",
]);

export const registrationFeedbackNpsHeaderStyles = cva([
  "flex w-full flex-col items-start gap-6 text-left",
  "lg:items-center lg:text-center",
]);

export const registrationFeedbackNpsTitleStyles = cva([
  "m-0 font-[Canela_Text,serif] text-[40px] font-black leading-[1.2] text-[#1B1C1D]",
]);

export const registrationFeedbackNpsQuestionStyles = cva([
  "m-0 max-w-[640px] font-[Poppins,sans-serif] text-sm font-medium leading-5 tracking-[0.25px] text-[#1B1C1D]",
  "lg:text-base lg:font-normal lg:leading-6 lg:tracking-[0.5px]",
]);

export const registrationFeedbackNpsScaleSectionStyles = cva([
  "flex w-full flex-col gap-3",
]);

export const registrationFeedbackNpsActionsStyles = cva([
  "flex w-full max-w-none flex-col items-center gap-4",
  "lg:max-w-[476px]",
]);

export const registrationFeedbackMaybeLaterStyles = cva([
  "flex h-12 w-full items-center justify-center",
  "border-0 bg-transparent p-0",
  "font-[Inter,Poppins,sans-serif] text-sm font-semibold leading-5 tracking-[0.1px] text-[#003049]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
  "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
]);

export const registrationFeedbackNpsErrorBannerWrapperStyles = cva([
  "w-full",
  "md:max-w-[402px] md:mx-auto",
  "lg:max-w-[476px]",
]);

export const registrationFeedbackNpsErrorBannerStyles = cva([
  "py-2 px-4 lg:py-4 lg:px-4",
  "[&_span]:tracking-[0.4px] lg:[&_span]:tracking-[0.25px]",
]);
